
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/accessibilitat",
      function () {
        return require("private-next-pages/corporatiu/atencio/accessibilitat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/accessibilitat"])
      });
    }
  